export const CLICK_CUSTOMER_RISK_AND_COVERAGE_SLIDEOUT_BUTTON = 'CLICK_CUSTOMER_RISK_AND_COVERAGE_SLIDEOUT_BUTTON';
export const VIEW_CUSTOMER_RISK_AND_COVERAGE_SLIDEOUT = 'VIEW_CUSTOMER_RISK_AND_COVERAGE_SLIDEOUT';
export const CLOSE_CUSTOMER_RISK_AND_COVERAGE_SLIDEOUT = 'CLOSE_CUSTOMER_RISK_AND_COVERAGE_SLIDEOUT';
export const SHOW_CUSTOMER_RISK_AND_COVERAGE_SLIDEOUT = 'SHOW_CUSTOMER_RISK_AND_COVERAGE_SLIDEOUT';
export const SET_SLIDEOUT_CONTENT = 'SET_SLIDEOUT_CONTENT';
